module.exports = __webpack_public_path__ + "img/block-1Icon@2x.86f5a10a.png";